import React from 'react';
import { XMLTester } from '../components/xml-tester/XMLTester';

export const XMLTesterPage: React.FC = () => {
  return (
    <div className="page-container">
      <XMLTester />
    </div>
  );
};
